<div>
  <div class="card">
    <div class="card-body">
      <picture class="picture">
        <img src="assets/govbr.png" class="img-fluid">
      </picture>
      <p class="card-descricao">Uma conta <b>gov.br</b> garante a identificação de cada cidadão que acessa os serviços digitais do governo.</p>
      <button class="btn btn-primary" data-testid="continuarParaGovBr" (click)="redirecionaAcessoGovBr()" [disabled]="disabled">
        Entrar com Gov.Br
      </button>
    </div>
    <div class="card-footer bg-transparent">
      <p>É necessário possuir conta gov.br <strong>nível ouro ou prata</strong> para utilizar a assinatura eletrônica avançada.</p>
      <p><a href="http://confiabilidades.acesso.gov.br/"  target="_blank">Clique aqui</a> para aumentar o nível da sua conta.</p>
    </div>
  </div>
</div>
